// Configuration for backend API URLs
const config = {
  // Determine if we're running in development (localhost) or production
  isDevelopment: () => {
    return window.location.hostname === 'localhost' || 
           window.location.hostname === '127.0.0.1' ||
           window.location.hostname.includes('localhost');
  },
  
  // Get the appropriate backend URL based on environment
  getBackendUrl: () => {
    const isDev = config.isDevelopment();
    const url = isDev ? 'http://localhost:8080' : 'https://mey-teaches-linux-amd64.onrender.com';
    
    return url;
  },
  
  // Get the full API URL for a specific endpoint
  getApiUrl: (endpoint) => {
    const baseUrl = config.getBackendUrl();
    const fullUrl = `${baseUrl}${endpoint}`;
    return fullUrl;
  }
};

export default config; 